module.exports = __webpack_public_path__ + "static/media/read-icon-blue.cdfb4ace.svg";